import { z } from "zod";
/**
 * Контракт endpoint'а PDF-экспорта отчёта о сверке нарядов и актов
 * (фича 034, specs/034-reconciliation-pdf-export/contracts/pdf-export.contract.md).
 *
 * Endpoint: `GET /api/reconciliation/runs/:runId/pdf`
 * Body 200-ответа — бинарный PDF-stream, в Zod не описывается.
 * Здесь описаны: path-params и envelope ошибок.
 */
/** Path-параметры запроса PDF-экспорта. */
export const PdfExportPathParamsSchema = z.object({
    runId: z.string().uuid(),
});
/**
 * Закрытый allow-list полей в `details` error envelope-а (FR-019a).
 *
 * Запрещено выводить в response любые иные поля (stack-trace, error.message,
 * userId, IP, parameters_snapshot и т. п.) — они логируются только на сервере
 * через Pino. Schema использует `.strict()`, что отбрасывает лишние ключи
 * с ошибкой валидации, предотвращая случайные утечки.
 */
export const PdfExportErrorDetailsSchema = z
    .object({
    /** UUID прогона — для трейсинга в логах. */
    runId: z.string().optional(),
    /** Текущий статус прогона — только для RUN_NOT_COMPLETED. */
    status: z.string().optional(),
    /** Machine-readable код подкатегории ошибки (опционально). */
    code: z.string().optional(),
})
    .strict();
/**
 * JSON error envelope для всех неуспешных ответов endpoint'а.
 * Соответствует `contracts/pdf-export.contract.md` секции «Error responses».
 */
export const PdfExportErrorSchema = z.object({
    error: z.enum([
        "VALIDATION_ERROR",
        "UNAUTHORIZED",
        "RUN_NOT_FOUND",
        "RUN_NOT_COMPLETED",
        "PDF_GENERATION_FAILED",
    ]),
    message: z.string(),
    details: PdfExportErrorDetailsSchema.optional(),
});
//# sourceMappingURL=pdf-export.js.map